import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';
import logo from './logo2.png';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Handle scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Sync state with Bootstrap collapse events
  useEffect(() => {
    const navBarCollapse = document.getElementById('navbarNav');
    
    const handleShown = () => setMobileMenuOpen(true);
    const handleHidden = () => setMobileMenuOpen(false);
    
    navBarCollapse.addEventListener('shown.bs.collapse', handleShown);
    navBarCollapse.addEventListener('hidden.bs.collapse', handleHidden);
    
    return () => {
      navBarCollapse.removeEventListener('shown.bs.collapse', handleShown);
      navBarCollapse.removeEventListener('hidden.bs.collapse', handleHidden);
    };
  }, []);

  const handleNavLinkClick = () => {
    const navBarCollapse = document.getElementById('navbarNav');
    if (navBarCollapse.classList.contains('show')) {
      new window.bootstrap.Collapse(navBarCollapse).hide();
    }
  };

  return (
    <nav className={`navbar navbar-expand-lg ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        <NavLink className="navbar-brand" to="/">
          <img src={logo} alt="Logo" className="nav-logo" />
        </NavLink>
        
        <button 
          className={`navbar-toggler ${mobileMenuOpen ? 'active' : ''}`}
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav" 
          aria-controls="navbarNav" 
          aria-expanded={mobileMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="toggler-icon top-bar"></span>
          <span className="toggler-icon middle-bar"></span>
          <span className="toggler-icon bottom-bar"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <NavLink exact to="/" className="nav-link" activeClassName="active" onClick={handleNavLinkClick}>Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/service" className="nav-link" activeClassName="active" onClick={handleNavLinkClick}>Services</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" className="nav-link" activeClassName="active" onClick={handleNavLinkClick}>About</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/programs" className="nav-link" activeClassName="active" onClick={handleNavLinkClick}>Programs</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/products" className="nav-link" activeClassName="active" onClick={handleNavLinkClick}>Products</NavLink>
            </li>
             <li className="nav-item">
              <NavLink to="/blogs" className="nav-link contact-link" activeClassName="active" onClick={handleNavLinkClick}>Blogs</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className="nav-link contact-link" activeClassName="active" onClick={handleNavLinkClick}>Contact</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Header;